import { useCrossBrowserContext } from 'hooks/useCrossBrowserContext';
import { FC } from 'react';
import { splitIntoChunksOf } from 'state/utils/array';

import { PairedActionsButton } from './PairedActionsButton';
import type { PairedQuoteAction, QuoteActionsProps } from './QuoteActions.connect';
import { connectQuoteAction } from './QuoteActions.connect';
export const Component: FC<QuoteActionsProps> = ({
  tabId,
  fullWidthPairedActions,
  halfWidthPairedActions,
  allPairedActions,
  isFormDirty,
  width,
  onPrice,
  children,
  btnClassName,
}) => {
  const { isDirty, isLocked } = useCrossBrowserContext();
  const isCrossBrowserFrozen = isDirty || isLocked;

  const halfWidthPairedActionsChunked = splitIntoChunksOf(halfWidthPairedActions, 2);
  if (width) {
    return (
      <>
        {children}
        {allPairedActions.map(({ action, advancedAction }: PairedQuoteAction) => (
          <PairedActionsButton
            className={btnClassName}
            key={action.name}
            tabId={tabId}
            action={action}
            advancedAction={advancedAction}
            isDisabled={action.isDisabled || isFormDirty || isCrossBrowserFrozen}
            width={width}
            onQuoteAction={onPrice}
            tooltip={action.tooltipKey}
          />
        ))}
      </>
    );
  }
  return (
    <div className="d-flex flex-column">
      {children}
      {fullWidthPairedActions.map(({ action, advancedAction }: PairedQuoteAction) => (
        <PairedActionsButton
          className={btnClassName}
          key={action.name}
          tabId={tabId}
          action={action}
          advancedAction={advancedAction}
          isDisabled={action.isDisabled || isFormDirty || isCrossBrowserFrozen}
          width={'full'}
          onQuoteAction={onPrice}
          tooltip={action.tooltipKey}
        />
      ))}
      <div className="d-flex flex-column">
        {halfWidthPairedActionsChunked.map(pairedActionsChunk => (
          <div
            className="d-flex gap-1"
            key={pairedActionsChunk.map(pairedActions => pairedActions.action.name).join('-')}
          >
            {pairedActionsChunk.map(({ action, advancedAction }: PairedQuoteAction) => (
              <PairedActionsButton
                className={btnClassName}
                key={action.name}
                tabId={tabId}
                action={action}
                advancedAction={advancedAction}
                isDisabled={action.isDisabled || isFormDirty || isCrossBrowserFrozen}
                width={'half'}
                onQuoteAction={onPrice}
                tooltip={action.tooltipKey}
              />
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export const QuoteActions = connectQuoteAction(Component);

QuoteActions.displayName = 'QuoteActions';
